import { render, staticRenderFns } from "./EventGiftCertificate.vue?vue&type=template&id=55b6c3e6&"
import script from "./EventGiftCertificate.vue?vue&type=script&lang=js&"
export * from "./EventGiftCertificate.vue?vue&type=script&lang=js&"
import style0 from "./EventGiftCertificate.vue?vue&type=style&index=0&id=55b6c3e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports